export const getServiceReports = `/reports/service-reports/partner`;
export const getAuditTrails = `/reports/audit-trails/partner`;
